module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/413.d4eeb0f8.png";